import {Box, Flex, Text} from "@chakra-ui/react";
import {InputLabel, StyledButton} from "../../index";
import {Link, useNavigate} from "react-router-dom";
import {useForm} from "react-hook-form";
import {useState} from "react";
import { ReactComponent as EmailIcon } from "../../../assets/icons/emailIcon.svg";
import { ReactComponent as LockIcon } from "../../../assets/icons/lock.svg";
import { ReactComponent as EyeIcon } from "../../../assets/icons/eye-closed.svg";
import {useSignIn, useUser} from "../../../core/hooks";
import {userInfo} from "../../../helpers/data-jsons";

export const LoginForm = ({isMobile}) => {
    const [showPassword, setShowPassword] = useState(false);
    // const {signIn, isLoading} = useSignIn()
    const {setUser} = useUser()
    const navigate = useNavigate()


    const {
        register,
        handleSubmit,
        formState: {errors, isValid, isDirty}} = useForm({
        mode: "onTouched",
        defaultValues: {
            email: '',
            password: '',
        }})

    const submit = (e) => {
        localStorage.setItem('token', 'ads654a6s5df46a54sd6f54a6sd54f6a54sd65f4a2scv1z3x2c1v')
        setUser(userInfo)
        navigate('/')
    }

    const togglePassword = () => {
        setShowPassword((prev) => !prev);
    }

    return (
        <form onSubmit={handleSubmit(submit)}>
            <Flex
                direction={'column'}
                gap={isMobile ? '32px' : '48px'}>
                <InputLabel
                    label={'Email'}
                    height={isMobile ? '40px' : '56px'}
                    fontSize={isMobile ? '14px' : '18px'}
                    isInvalid={!!errors.email}
                    {...register('email', {
                        required: 'Email is required',
                        pattern: {
                            value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                            message: "Invalid email address",
                        },
                    })}
                    placeholder={'Email or Phone number'}
                    maxW={'565px'}
                    leftAddon={<EmailIcon width={isMobile ? '20px' : '25px'}/>}/>
                <Box >
                    <InputLabel
                        label={'Password'}
                        fontSize={isMobile ? '14px' : '18px'}
                        height={isMobile ? '40px' : '56px'}
                        isInvalid={!!errors.password}
                        {...register('password', {
                            required: 'Password is required',
                        })}
                        type={showPassword ? "text" : "password"}
                        rightAddon={<EyeIcon onClick={togglePassword} width={isMobile ? '20px' : '25px'}/>}
                        placeholder={'Password'}
                        maxW={'565px'}
                        leftAddon={<LockIcon width={isMobile ? '20px' : '25px'}/>}/>
                    <Text
                        as={Link}
                        to={'/auth/forget-password'}
                        fontSize={isMobile ? 'body.xs' : 'body.md'}>
                        Forget password?
                    </Text>
                </Box>
                <StyledButton
                    disabled={!(isValid && isDirty)}
                    height={isMobile ? '40px' : '56px'}
                    fontSize={'body.lg'}
                    type={'submit'}
                    width={'full'}>
                    Log in
                </StyledButton>
            </Flex>
        </form>
    )
}